import { useMemo } from "react";

import { BMText } from "@traveloka/district-bloom";
import IcProductHotelFill16 from "@traveloka/icon-kit-web/react/IcProductHotelFill16";
import IcTransportFlightFill16 from "@traveloka/icon-kit-web/react/IcTransportFlightFill16";

import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";
import { ProductType } from "../../../types";
import BMView from "../../View/BMView";

type Props = {
  product: ProductType;
  amount: string;
  date: string;
};

export default function SpendingStatCard(props: Props) {
  const { product, amount, date } = props;

  const { CorporateTransactionDataAnalytics: cr } = useMobileContentResource();

  const content = useMemo(
    () => ({
      FLIGHT: {
        title: cr.flightAverageSpending,
        icon: IcTransportFlightFill16,
      },
      HOTEL: {
        title: cr.hotelAverageSpending,
        icon: IcProductHotelFill16,
      },
      TRAIN: {
        title: null,
        icon: null,
      },
    }),
    [cr]
  );

  const Icon = content[product].icon;

  return (
    <BMView spacing="sm">
      <BMView row spacing="xs">
        {Icon && <Icon />}
        <BMText variant="uiNormal" ink="BMStyleTextInkSecondary">
          {content[product].title}
        </BMText>
      </BMView>
      <BMView>
        <BMText variant="titleNormal">{amount}</BMText>
        <BMText variant="uiNormalLi" ink="BMStyleTextInkSecondary">
          {date}
        </BMText>
      </BMView>
    </BMView>
  );
}
